import { withInstall } from '@sgui-plus/utils/with-install'
import Drawer from './src/drawer.vue'

export const SgDrawer = withInstall(Drawer)
export default SgDrawer

export * from './src/drawer'
